import { List, Record } from "immutable";

import { AccessReviewReportModel } from "./AccessReviewReportModel";
import { AccessReviewResourcePermissionModel } from "./AccessReviewResourcePermissionModel";
import { IntegrationResourceModel } from "./IntegrationResourceModel";

interface IAccessReviewResourceStatistics {
  permissionsStatus: {
    approved: number;
    denied: number;
    flagged: number;
    pending: number;
  };
}

const defaults = {
  accessReviewReport: null as AccessReviewReportModel | null,
  accessReviewReportId: "",
  accessReviewResourcePermissions: null as List<AccessReviewResourcePermissionModel> | null,
  id: "",
  integrationResource: null as IntegrationResourceModel | null,
  integrationResourceId: "",
  permissionsCount: null as null | number,
  statistics: null as IAccessReviewResourceStatistics | null,
};

export type TAccessReviewResourceModel = typeof defaults;

export class AccessReviewResourceModel extends Record<TAccessReviewResourceModel>(defaults) {
  public get notPendingPermissionsSize(): number {
    if (this.statistics) {
      return this.permissionsSize - (this.statistics.permissionsStatus.pending || 0);
    }
    if (this.accessReviewResourcePermissions) {
      return this.accessReviewResourcePermissions.filter((permission) => permission.status !== "pending").size;
    }
    return 0;
  }

  public get permissionsSize(): number {
    return this.permissionsCount || this.accessReviewResourcePermissions?.size || 0;
  }

  public get status(): "done" | "inProgress" | "pending" {
    if (this.notPendingPermissionsSize > 0) {
      return this.notPendingPermissionsSize === this.permissionsSize ? "done" : "inProgress";
    }
    return "pending";
  }

  static fromServerData(data: unknown): AccessReviewResourceModel {
    const {
      accessReviewReport,
      accessReviewReportId,
      accessReviewResourcePermissions,
      id,
      integrationResource,
      integrationResourceId,
      permissionsCount,
      statistics,
    } = data as TAccessReviewResourceModel;
    return new AccessReviewResourceModel({
      accessReviewReport: accessReviewReport ? AccessReviewReportModel.fromServerData(accessReviewReport) : null,
      accessReviewReportId,
      accessReviewResourcePermissions: accessReviewResourcePermissions
        ? List(accessReviewResourcePermissions.map(AccessReviewResourcePermissionModel.fromServerData))
        : null,
      id,
      integrationResource: integrationResource ? IntegrationResourceModel.fromServerData(integrationResource) : null,
      integrationResourceId,
      permissionsCount,
      statistics,
    });
  }
}
